import { ReactElement } from 'react';
import IterationDetailsPage from 'pages/campaign/iteration/IterationDetailsPage';
import IterationSummaryPage from 'pages/campaign/iteration/Summary';
import CohortsPage from 'pages/campaign/iteration/[iterationId]/Cohorts';
import IterationRoutingPlanPage from 'pages/campaign/iteration/[iterationId]/RoutingPlan';
import IterationReviewers from 'pages/campaign/iteration/IterationReviewers';
import SummaryReportsPage from 'pages/campaign/iteration/[iterationId]/SummaryReports/SummaryReports';
import SummaryReportPage from 'pages/campaign/iteration/[iterationId]/SummaryReports/SummaryReport';
import CopyIteration from 'pages/campaign/iteration/[iterationId]/copy-iteration/CopyIteration';
import createRoutingRuleRoutes from 'routes/RoutingRuleRoutes';
import createFilterRuleRoutes from 'routes/FilterRuleRoutes';
import createSuppressionRuleRoutes from 'routes/SuppressionRuleRoutes';
import SummaryReportRequestReviewersPage
  from 'pages/campaign/iteration/[iterationId]/SummaryReports/SummaryReportRequestReviewersPage.tsx';
import RoutingPlansUpdatedPage from 'pages/campaign/iteration/RoutingPlansUpdated';
import CreateIterationDetailsPage from 'pages/campaign/iteration/CreateIterationDetailsPage';
import IterationRunTypePage from 'pages/campaign/iteration/[iterationId]/IterationRunTypePage';
import SummaryReportRequestedPage from 'pages/campaign/iteration/[iterationId]/SummaryReportRequestedPage';
import ArchiveIterationConfirmationPage from 'pages/campaign/iteration/ArchiveIterationConfirmationPage';
import IterationDetailsConfirmationPage from 'pages/campaign/iteration/IterationDetailsConfirmationPage';

const createIterationRoutes = (withCampaignLoader: (component: ReactElement) => ReactElement) => ({
  path: 'iteration',
  children: [
    { path: 'new', element: withCampaignLoader(<CreateIterationDetailsPage />) },
    {
      path: ':iterationId',
      children: [
        { path: 'summary/reports/:batchId/reviewers', element: withCampaignLoader(<SummaryReportRequestReviewersPage />) },
        { path: 'summary/reports/:batchId', element: withCampaignLoader(<SummaryReportPage />) },
        { path: 'summary/reports', element: withCampaignLoader(<SummaryReportsPage />) },
        { path: 'summary', element: withCampaignLoader(<IterationSummaryPage />) },
        { path: 'key-details', element: withCampaignLoader(<IterationDetailsPage />) },
        { path: 'key-details/confirmation', element: withCampaignLoader(<IterationDetailsConfirmationPage />) },
        { path: 'message-plan', element: withCampaignLoader(<IterationRoutingPlanPage />) },
        { path: 'cohorts', element: withCampaignLoader(<CohortsPage />) },
        { path: 'copy', element: withCampaignLoader(<CopyIteration />) },
        { path: 'reviewers', element: withCampaignLoader(<IterationReviewers />) },
        { path: 'message-plans-updated', element: withCampaignLoader(<RoutingPlansUpdatedPage />) },
        { path: 'select-run-type', element: withCampaignLoader(<IterationRunTypePage />) },
        { path: 'summary-report-requested', element: withCampaignLoader(<SummaryReportRequestedPage />) },
        { path: 'archive-iteration-confirmation', element: withCampaignLoader(<ArchiveIterationConfirmationPage />) },
        createRoutingRuleRoutes(withCampaignLoader),
        createFilterRuleRoutes(withCampaignLoader),
        createSuppressionRuleRoutes(withCampaignLoader),
      ],
    },
  ],
});

export default createIterationRoutes;
